module.exports = __webpack_public_path__ + "pc/img/puzzle_bg_01.3f751a7d.png";